// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__SXzBg","active":"styles_active__iTyOZ"};